import { SET_CBODY_CLASS } from '../types';

export default {
	namespaced: true,

	state: {
		cBodyClass: null,
	},

	mutations: {
		[SET_CBODY_CLASS](state, cBodyClass) {
			state.cBodyClass = cBodyClass;
		},
	},

	actions: {
		setCBodyClass({ commit }, cBodyClass) {
			commit(SET_CBODY_CLASS, cBodyClass);
		},
	},
};
